import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Utils } from '../../../../../core/services/utils.service';
import { SHARED_MODULES } from '../../../../../shared.';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-tree-item-checkbox',
    template: `
		<li>
			<div class="item">
              <span class="label"
					(click)="onCheck(element)"
			  >   
                  <mat-checkbox #item
								[class.checked-shadow]="element.checkedShadow && !element.checked"
								[style.pointer-events]="'none'"
								[indeterminate]="element.checkedShadow && !element.checked"
								[(ngModel)]="element.checked"
				  >
                      <span [innerHtml]="(element.name === 'ALL' || element.isTranslate) ? (element.name | translate) : element.name"></span>
                  </mat-checkbox>
              </span>
				@if (element.has_children && !element.loading) {
					<fa-icon [icon]="element.opened? 'chevron-up': 'chevron-down'" (click)="openHide(element)"></fa-icon>
				}
				@if (element.loading) {
					<fa-icon icon="spinner" class="plus-icon fa-spin"></fa-icon>
				}
			</div>
			@if (element.opened && element.children.length) {
				<ul>
					@for (category of element.children; track $index) {
						<app-tree-item-checkbox
								[element]="category"
								[loadChildrenCallback]="loadChildrenCallback"
								(check)="onCheck($event)"
						></app-tree-item-checkbox>
					}
				</ul>
			}
		</li>
	`,
    styleUrls: ['./tree-item-checkbox.component.scss'],
	imports: [SHARED_MODULES, FaIconComponent],
    standalone: true
})
export class TreeItemCheckboxComponent {

	@Input() element: any;
    @Input() loadChildrenCallback: (id?: number) => Promise<any[]>;

	@Output('check') check: EventEmitter<any> = new EventEmitter<any>();

	constructor() {}

	async openHide(element: any): Promise<void> {
		if (element.opened) {
			element.opened = false;
			Utils.rec(element.children, ((e: any): void => {
				e.opened = false;
			}));
			return;
		}
		if (element.hasOwnProperty('children') && Array.isArray(element.children) && element.children.length) {
			element.opened = true;
			return;
		}

		if (this.loadChildrenCallback) {
			element.loading = true;
			const children: any[] = await this.loadChildrenCallback(element.id);
			children.forEach((child: any): void => {
				child.parent = element;
				child.checked = false;
				child.iconName = 'plus';
			});
			element.children = children;
			element.loading = false;
			element.opened = true;
			Utils.rec([this.element], (e: any): void => {
				if (e.children && e.children.length > 0) {
					e.children.forEach((i: any): void => {
						i.checked = e.checked;
					});
				}
			});
		}
	}

	onCheck(element: any): void {
		this.check.emit(element);
	}
}
